const algoliaAppId = 'TLOBZ19IU2'
const algoliaApiKey = '2ab4ba3c36aa0a23e15c534dcccf99b8'
const placeSearchIndex = 'place_search'
const placeSearchSuggestionsIndex = 'place_search_query_suggestions'
const locationSearchIndex = 'location_search'
const locationSearchSuggestionsIndex = 'location_search_query_suggestions'

export {
  algoliaAppId,
  algoliaApiKey,
  placeSearchIndex,
  placeSearchSuggestionsIndex,
  locationSearchIndex,
  locationSearchSuggestionsIndex,
}
